export default
{
    name: 'app-animated-text',

    props:
    {
        text: { type: String, default: '' },
        active: { type: Boolean, default: false },
        duration: { type: Number, default: 1.6 },
        steps: { type: Number, default: 10 },
        hoverable: { type: Boolean, default: false }
    },

    computed:
    {
        formatedText: function()
        {
            let words = this.text.split(/\s(?=[^?])/)
            words = words.map((_item) => _item + ' ')

            return words
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-animated-text/script.js